import(/* webpackMode: "eager" */ "/app/app/(app)/dashboard/page.tsx");
